module.exports = __webpack_public_path__ + "img/img-led-guide.3a13f2e2.jpg";